module.exports = __webpack_public_path__ + "img/finger_clicking.d33f0af3.svg";